import { useEffect, useState } from "react";
import { HStack, VStack } from "../components/utils";
import { PrimaryCTAButton } from "../pages/quickRound/CTAButtonComponents";

type ArticleModalProps = {
  name: string;
  description: string;
  onPrimaryAction: () => void;
};

export function parseRTFToHTML(input: string): string {
  const decodeEntities = (text: string) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  };

  if (!input || input.trim() === "") return "";

  if (
    /^<t[^>]*>\s*<\/t>$/.test(input.trim()) ||
    /^<t[^>]*\/>$/.test(input.trim())
  ) {
    return "";
  }

  const isXML = /<r>[\s\S]*?<\/r>/.test(input);

  if (isXML) {
    const runs = input.match(/<r>[\s\S]*?<\/r>/g);
    if (!runs) return "";

    const formattedRuns = runs
      .map((run) => {
        const tMatch = run.match(/<t[^>]*>([\s\S]*?)<\/t>/);
        const rawText = tMatch?.[1] ?? "";
        if (rawText.trim() === "") return "";

        let text = decodeEntities(rawText);

        // Replace line breaks with <br>
        text = text.replace(/\r?\n/g, "<br/>");

        // Apply styles
        if (/<b\/>/.test(run)) text = `<b>${text}</b>`;
        if (/<i\/>/.test(run)) text = `<i>${text}</i>`;
        if (/<u\/>/.test(run)) text = `<u>${text}</u>`;

        return text;
      })
      .filter(Boolean);

    // Join with <br/> to force line breaks between runs
    return formattedRuns.join("<br/>");
  } else {
    const text = decodeEntities(input).trim();
    if (text === "") return "";

    return text
      .replace(/\r?\n/g, "<br/>");
  }
}

function ArticleModal({
  name,
  description,
  onPrimaryAction = () => {},
}: ArticleModalProps) {
  const [rtfText, setRtfText] = useState("");
  const [htmlText, setHtmlText] = useState("");

  useEffect(() => {
    const html =
      parseRTFToHTML(rtfText) === ""
        ? "Article not available"
        : parseRTFToHTML(rtfText);
    setHtmlText(html);
  }, [rtfText]);

  useEffect(() => {
    if (!description) return;
    setRtfText(description);
  }, [description]);

  return (
    <div className="w-full min-w-[300px] sm:min-w-[400px] md:min-w-[500px] bg-white rounded border-2 border-gray-300">
      <HStack className="text-lg text-left font-medium border-b pt-4 pb-1 px-6">
        <h6 className="flex-1">{name}</h6>
      </HStack>
      <VStack className="w-full px-6 py-4 gap-6">
        <div dangerouslySetInnerHTML={{ __html: htmlText }} />
        <HStack className="justify-end h-8">
          <PrimaryCTAButton
            event-name="Close Artcle Modal"
            onClick={() => {
              onPrimaryAction();
            }}
          >
            close
          </PrimaryCTAButton>
        </HStack>
      </VStack>
    </div>
  );
}

export default ArticleModal;
